module.exports = __webpack_public_path__ + "img/log-out.8df207bf.svg";